"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = exports.DisplayError = exports.displayErrors = exports.displayAndLogErrorWithMessage = void 0;
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-console */
const React = __importStar(require("react"));
const ZAlert_1 = require("../components/ZAlert/ZAlert");
const ll_1 = require("../languages/ll");
const axios_1 = __importDefault(require("axios"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.displayAndLogErrorWithMessage = (error, messageKey, issueAlert) => {
    if (axios_1.default.isCancel(error)) {
        return;
    }
    issueAlert &&
        issueAlert({
            type: "error",
            header: "Error",
            message: messageKey,
            key: messageKey
        });
    error.description = error.message;
    error.message = ll_1.ll(messageKey);
    console.error(error.toJSON ? error.toJSON() : error);
};
exports.displayErrors = (errors, issueAlert) => {
    errors.forEach((error) => {
        issueAlert({
            type: "error",
            header: error.details ? error.message : "Error",
            message: error.details ? error.details : error.message
        });
    });
};
exports.DisplayError = (props) => {
    const { error, header, message } = props;
    const { issueAlert } = ZAlert_1.useAlerts();
    React.useEffect(() => {
        const mess = message ||
            (error && error.message) ||
            (error && error.description) ||
            "An unknown error occurred.";
        error &&
            !axios_1.default.isCancel(error) &&
            issueAlert({
                type: "error",
                header: header || "Error",
                message: mess,
                key: `${header}:${mess}`,
                localize: false
            });
    }, [error, message, header, issueAlert]);
    return null;
};
const ErrorSpan = styled_components_1.default.span `
   color: red;
   white-space: pre-line;
`;
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }
    static componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Error!!! " + error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (React.createElement(React.Fragment, null,
                React.createElement(ErrorSpan, null, this.state.error &&
                    this.state.error.name &&
                    `${ll_1.ll(this.state.error.name)}: ${this.state.error.message} 
                     (${this.state.error.description || ""})`),
                this.state.error && React.createElement(exports.DisplayError, { error: this.state.error })));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=errors.js.map